import { Component, Input } from '@angular/core';
import { BillableEntity } from '@pdp/common';
import { NgFor, LowerCasePipe, DecimalPipe } from '@angular/common';

@Component({
    selector: 'pdp-total-price-shop',
    templateUrl: './total-price-shop.component.html',
    styleUrls: ['./total-price-shop.component.scss'],
    imports: [NgFor, LowerCasePipe, DecimalPipe]
})
export class TotalPriceShopComponent {

  @Input()
  public resource: BillableEntity<any>;
}
